import { faKey, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
//import AuthSocialButtons from 'components/common/AuthSocialButtons';
import { Col, Form, Row } from 'react-bootstrap';
import { useNavigate, Navigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useState } from 'react';

const SignInForm = ({ layout }: { layout: 'simple' | 'card' | 'split' }) => {
  const navigate = useNavigate();

  const [usuario, setusuario] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState('');
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:2000'; 

  const handleUsuarioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setusuario(event.target.value);
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };


  const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
  e.preventDefault();
  setError(''); // Clear previous errors

  try {
    const response = await axios.post(`${apiUrl}/auth/login`, { usuario, password });
    localStorage.setItem('token', response.data.token);
    navigate('/app/apps/project-management/procesos-list-view');
  } catch (err) {
  let serverMessage = 'Error al conectar con el servidor';

  if (axios.isAxiosError(err)) {
    // TypeScript now knows 'err' has the response property
    serverMessage = err.response?.data?.error || serverMessage;
  } else {
    // Handle non-axios errors (like syntax errors in your code)
    console.error('Non-Axios error:', err);
  }
  setError(serverMessage);
}
};

  return (
    <>
      <div className="text-center mb-7">
        <h3 className="text-body-highlight">Ingresar a Procureitor</h3>
      </div>
      <Form.Group className="mb-3 text-start">
        <Form.Label htmlFor="email">Usuario</Form.Label>
        <div className="form-icon-container">
          <Form.Control
            id="user"
            type="user"
            className="form-icon-input"
            placeholder="usuario"
            value={usuario}
            onChange={handleUsuarioChange}
          />
          <FontAwesomeIcon icon={faUser} className="text-body fs-9 form-icon" />
        </div>
      </Form.Group>
      <Form.Group className="mb-3 text-start">
        <Form.Label htmlFor="password">Contraseña</Form.Label>
        <div className="form-icon-container">
          <Form.Control
            id="password"
            type="password"
            className="form-icon-input"
            placeholder="Contraseña"
            value={password}
            onChange={handlePasswordChange}
          />
          <FontAwesomeIcon icon={faKey} className="text-body fs-9 form-icon" />
        </div>
      </Form.Group>
      <Row className="flex-between-center mb-7">
        <Col xs="auto">
          <Form.Check type="checkbox" className="mb-0">
            <Form.Check.Input
              type="checkbox"
              name="remember-me"
              id="remember-me"
              defaultChecked
            />
            <Form.Check.Label htmlFor="remember-me" className="mb-0">
              Recordarme
            </Form.Check.Label>
          </Form.Check>
        </Col>
      </Row>
      <Button variant="primary" className="w-100 mb-3" onClick={handleSubmit}>
        Enviar
      </Button>
      {error && <div className="alert alert-danger py-2">{error}</div>}
      
    </>
  );
};

export default SignInForm;
